$(function () {

  var field = 'registration';
  var url = window.location.href;
  if(url.indexOf('?' + field + '=') !== -1){
    console.log('registration pending exists in url');
    $('.registration-pending').css('display','block');
  }else{
    
    console.log('registration pending does not exist');
  }

  
  $("#login-to-see-price").on("click", function () {

    $('#login-modal').fadeIn();

  });

  $('#login-modal').keypress(function (e) {
   var key = e.which;
   if(key == 13)  // the enter key code
    {
      console.log('enter key pressed');
      //$('#dynamic-login-button').click();
      return false;  
    }
  });   

  
  $("#dynamic-login-button").on("click", function () {
    $('#dynamic-login-button').text('Processing...');
    var email_address = $('#CustomerLoginEmail').val();
    var password = $('#CustomerLoginPassword').val();
    $('.success-message-login').removeClass('show').addClass('hide');
  console.log('EMAIL: ' + email_address + ' / PASSWORD: '  + password);

    login(email_address, password).done(function (html) {  
      console.log(html.indexOf('Incorrect email or password.'));
      if (html.indexOf('Incorrect email or password.') !== -1) {
        // invalid password - show a message to the user
        $('.success-message-login').text('Incorrect email or password.').css('color','red').removeClass('hide').addClass('show');
        $('#dynamic-login-button').text('LOGIN');
      } else {
        $('#dynamic-login-button').css('display','none');
        console.log('good user credentials');
        $('.success-message-login').text('Successfully logging you in!').css('color','green').removeClass('hide').addClass('show');
        setTimeout(function() {
                    window.location.reload();
                }, 2000);                
      }
    });

    function login(email, password) {  
      var data = {
        'customer[email]': email_address,
        'customer[password]': password,
        form_type: 'customer_login',
        utf8: '✓'
      };
    
      var promise = $.ajax({
        url: '/account/login',
        method: 'post',
        data: data,
        dataType: 'html',
        async: true
      });
    
      return promise;
    }

      //console.log(promise);
      /*if(data.statusText == "success"){
        $('#Success_Message').text(data.message).show();
        setTimeout(function() {
                    $('#Success_Message').hide();
                    location.reload();
                }, 4000);
      } else{
        console.log('failed');
      }*/


        
    //console.log(promise);

  });

  $(".customer_register_link").on("click", function () {
    var pathname = window.location.pathname;
    console.log('path: ' + pathname);
    var redirect = 'https://mdjadvantage.com/account/register?redirect=' + pathname;
    window.location.href = redirect;
    //$('#loginForm').removeClass('show').addClass('hide');
    //$('#registerForm').removeClass('hide').addClass('show');
    //$('#RecoverPasswordForm').removeClass('show').addClass('hide');
  });

  $(".login-button").on("click", function () {
    $('#loginForm').removeClass('hide').addClass('show');
    $('#registerForm').removeClass('show').addClass('hide');
    $('#RecoverPasswordForm').removeClass('show').addClass('hide');
  });

  $(".recover-password-button").on("click", function () {
    $('#loginForm').removeClass('show').addClass('hide');
    $('#registerForm').removeClass('show').addClass('hide');
    $('#RecoverPasswordForm').removeClass('hide').addClass('show');
  });

  $("#registration_form").on("click", function () {
       <!--------------------------------- For Lead ID -------------------------------------------------!>
            const urlParams = new URLSearchParams(location.search);
               for (var lead_key of urlParams.keys()) {
                    console.log(key);
              }
              for (var lead_value of urlParams.values()) {
                  console.log(lead_value);
              }
      var lead_id = lead_value;
      
      if(lead_id) {
        var leadjson = {
          "lead_id":lead_id
        };
        
        $.post("https://shopify.braintreeeasysoft.com/mdj/shop-api/customer-lead", JSON.stringify(leadjson))
         .done(function(data) {
           // console.log(data);
         });
      }   
    
       <!--------------------------------- End For Lead ID -------------------------------------------------!>
      $("#registration_form").on("click", function () {
        var error = 0;
        var store_name = $('#store_name').val();
        var First_Name = $('#FirstName').val();
        var Last_Name = $('#LastName').val();
        var phone_number = $('#store_number').val();
        var Email = $('#Email').val();
        var CreatePassword = $('#CreatePassword').val();
          
        <!-------------------------------------------- Validation Check ----------------------------------!>
        var regEmail= /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        var phoneRegex = /^(\d{3})[- ]?(\d{3})[- ]?(\d{4})$/;
        
        if (store_name === '') {
     event.preventDefault();
     $('#store_nameError').text('*Please Fill Store Name.');
     return false;
     } else if(!isNaN(store_name)){
     event.preventDefault();
     $('#store_nameError').text('*Please Fill Valid Store Name.');
     return false;
     } else if(store_name.length < 5){
     event.preventDefault();
     $('#store_nameError').text('*Please Fill Minimum 5 Characters.');
     return false;
     } else if(store_name.length > 20){
     event.preventDefault();
     $('#store_nameError').text('*Please Fill Valid Store Name.');
     return false;
     }else{
     $('#store_nameError').text('');
     }
    
     if(First_Name === ''){
     event.preventDefault();
     $('#FirstNameError').text('*Please Fill First Name.');  
     return false;
      } else if(!isNaN(First_Name)){
     event.preventDefault();
     $('#FirstNameError').text('*Please Fill Valid First Name.');
     return false;
     } else if(First_Name.length < 5){
     event.preventDefault();
     $('#FirstNameError').text('*Please Fill Minimum 5 Characters.');
     return false;
     } else if(First_Name.length > 20){
     event.preventDefault();
     $('#FirstNameError').text('*Please Fill Valid First Name.');
     return false;
     }else{
     $('#FirstNameError').text('');
     }
    
     if(Last_Name === ''){
     event.preventDefault();
     $('#LastNameError').text('*Please Fill Last Name.');  
     return false;
    } else if(!isNaN(Last_Name)){
     event.preventDefault();
     $('#LastNameError').text('*Please Fill Valid Last Name.');
     return false;
     } else if(Last_Name.length < 5){
     event.preventDefault();
     $('#LastNameError').text('*Please Fill Minimum 5 Characters.');
     return false;
     } else if(Last_Name.length > 20){
     event.preventDefault();
     $('#LastNameError').text('*Please Fill Valid Last Name.');
     return false;
     }else{
     $('#LastNameError').text('');
     }
    
     if(phone_number === ''){
     event.preventDefault();
     $('#phone_numberError').text('*Please Fill Store Phone.');  
     return false;
     } else if(!phoneRegex.test(phone_number)){
     event.preventDefault();
     $('#phone_numberError').text('*Please Fill Valid Number.');  
     return false;
    
     } else{
     $('#phone_numberError').text('');
     }
    
     if(Email === ''){
     event.preventDefault();
     $('#EmailError').text('*Please Fill Email.');  
     return false;
     } else if(!regEmail.test(Email)){
     event.preventDefault();
     $('#EmailError').text('*Please Fill Valid Email.'); 
     return false;
     } else{
     $('#EmailError').text('');   
     }
    
     if(CreatePassword === ''){
     event.preventDefault();
     $('#CreatePasswordError').text('*Please Fill Password.');  
     return false;
     } else{
     $('#CreatePasswordError').text('');
     }
    
     if ($('#CustomerCheck').val() !== '') {
      event.preventDefault();
    }
       
     <!-------------------------------------------- End Validation Check ----------------------------------!>
    $("#registration_form").text("Processing...");
    var cell_phone_number = $('#cell_phone_number').val();
    var createCustomerData = {
    "email": Email,
    "first_name": First_Name,
    "last_name": Last_Name,
    "cell_phone": cell_phone_number,
    "store_name": store_name,
    "store_phone": phone_number,
    "password": CreatePassword,
    "lead_id":lead_id
    }
     $.post("https://shopify.braintreeeasysoft.com/mdj/shop-api/customer", JSON.stringify(createCustomerData))
        .done(function(data) {
          if(data.exists){
            $('#Success_Message').text(data.message).show();
            setTimeout(function() {
                        $('#Success_Message').hide();
                        location.reload();
                    }, 4000);
          } else{
            $('#Success_Message').text(data.message).show();
            setTimeout(function() {
                        $('#Success_Message').hide();
                      location.reload();
                    }, 4000);
          }
          
        }); 

  });

  });

});

